<template>
  <div v-if="filter_current_settings !== null">
    <main-filter
      v-model="filter_current_settings"
      :translations="translations"
      :infant_max_age="infant_max_age"
      :pricelist_url="pricelist_url"
      ref="filterEl"
      @completeFilter="completeFilter"
    ></main-filter>

    <QuickFilter
      :available_sorts="available_sorts"
      :available_months="available_months"
      :translations="translations"
      v-model="filter_current_settings.sort"
      v-if="terms_data.length > 0"
      @completeFilter="completeFilter"
      @presetDates="presetDates($event)"
    ></QuickFilter>

    <div class="fshr-termOverview" :class="{ 'fshr-dataLoading': is_loading }">
      <ul class="fshr-termOverview-items" v-if="terms_data.length > 0">
        <term-line
          v-for="term in terms_data"
          :key="term.term_id"
          :term="term"
          :currency="currency"
          :api_url="api_url_detail"
          :api_url_pricing="api_url_pricing"
          :reservation_url="reservation_url"
          :translations="translations"
          :filter_settings="filter_current_settings"
          :infant_max_age="infant_max_age"
          :pp="pp"
        ></term-line>
      </ul>

      <div class="fshr-termOverview-noterms" v-else>
        <span v-if="typeof termsNotFound == 'string'">{{ termsNotFound }}</span>
        <span v-else>{{ getTranslation("zadneTerminy") }}</span>
      </div>

      <Paging
        :translations="translations"
        v-model="filter_current_settings.paging"
        v-if="terms_data.length > 0"
        @completeFilter="completeFilter"
      ></Paging>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import axios from "axios";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import { setupCalendar } from "v-calendar";
import filter_settings_termsoverview from './props/filter_settings_termsoverview.json'
import translations_termsoverview from './props/translations_termsoverview.json';
import terms_termsoverview from './props/terms_termsoverview.json';

setupCalendar();

export default {
  name: "terms-overview",
  components: {
    QuickFilter: () => import("./QuickFilter"),
    FilterItem: () => import("./FilterItem"),
    Paging: () => import("./Paging"),
    TermLine: () => import("./TermLine"),
    MainFilter: () => import("./MainFilter"),
  },
  data: function () {
    return {
      is_loading: false,
      terms_data: [],
      filter_current_settings: null,
      termsNotFound: false,
    };
  },
  mounted() {
    this.setUpFilter();

    if (this.language === "cz") {
      require("moment/locale/cs");
    } else {
      require("moment/locale/" + this.language);
    }

    this.terms_data = this.terms;
  },
  methods: {
    presetDates: function (data){
      setTimeout(() => {
        let filter_current_settings = this.deepCopy(this.filter_current_settings);
        this.getFilter(filter_current_settings.filters, 'calendar').value.range = data;
        this.filter_current_settings = filter_current_settings;
        this.$root.$emit("resetPaging");
        this.completeFilter();
      }, 300);
    },
    completeFilter: function (){
      this.$root.$emit("closeSubinfoAll");
      this.setLoading();
      this.updateURL();

      setTimeout(() => {
        this.fetchData();
        this.$root.$emit("resetSubinfos");
      }, 1500);
    },
    updateURL: function () {
      let calendar = this.getFilter(this.filter_current_settings.filters, "calendar");
      let termto = this.$moment(
        calendar.value.range.end
      ).format("YYYY-MM-DD");
      let termfrom = this.$moment(
        calendar.value.range.start
      ).format("YYYY-MM-DD");
      let nights = calendar.value.nights.map(el=> el.value).join(",");

      let query = JSON.parse(JSON.stringify(this.$route.query));

      if(query.termto !== termto || query.termfrom !== termfrom || query.nights !== nights){
        query.termto = termto;
        query.termfrom = termfrom;
        if(nights.length === 0){
          delete query.nights;
        }else{
          query.nights = nights;
        }
        let route = { path: "", query: query };
        this.$router.push(route);
      }
    },
    setUpFilter: function () {
      let filter_settings = JSON.parse(JSON.stringify(this.filter_settings));
      let calendar = this.getFilter(filter_settings.filters, 'calendar');

      calendar.value.range.start = new Date(calendar.value.range.start);
      calendar.value.range.end = new Date(calendar.value.range.end);

      filter_settings.sort = this.sort_default_value;
      filter_settings.paging = this.paging_settings_default;

      this.filter_current_settings = filter_settings;

      this.loadParamsFromUrl();
    },
    loadParamsFromUrl: function () {
      let proceedRefresh = false;
      let calendar = this.getFilter(this.filter_current_settings.filters, 'calendar');
      if(this.$route.query.hasOwnProperty("nights")){
        if(this.$route.query.nights === "-1"){
          calendar.value.nights = [];

        }else{
          calendar.value.nights = this.$route.query.nights.split(',').map((item)=>{
            let available = calendar.availables.available_nights.reduce((acc, available)=>{
              if(parseInt(item) === available.value){
                acc = available;
              }
              return acc;
            }, null);
            if(available !== null){
              return available;
            }
            return false;
          });
          proceedRefresh = true;
        }
      }

      if (
        this.$route.query.hasOwnProperty("termfrom") &&
        this.$route.query.hasOwnProperty("termto")
      ) {
        let valid =
          this.$moment(this.$route.query.termfrom).isValid() &&
          this.$moment(this.$route.query.termto).isValid();
        if (valid) {

          calendar.value.range.start = new Date(
            this.$route.query.termfrom
          );
          calendar.value.range.end = new Date(
            this.$route.query.termto
          );
          proceedRefresh = true;
        } else {
          alert("Zadané datum v URL není platné.");
        }
      }

      if (!this.is_loading && proceedRefresh) {
        this.completeFilter();
      }
    },
    fetchData: function () {

      var newData = JSON.parse(JSON.stringify(this.filter_current_settings));

      //newData.term.range.start = this.$moment(newData.term.range.start).unix();
      //newData.term.range.end = this.$moment(newData.term.range.end).unix();

      let calendar = this.getFilter(newData.filters, 'calendar');

      calendar.value.range.start = this.$moment(
          calendar.value.range.start
      ).format("DD-MM-YYYY");
      calendar.value.range.end = this.$moment(
          calendar.value.range.end
      ).format("DD-MM-YYYY");

      axios
        .post(this.api_url, JSON.stringify(newData))
        .then( (response) => {
          if (response.status === 200) {
            if (response.data.status === 1) {
              this.$set(this, "terms_data", response.data.payload);
              this.filter_current_settings.paging.records_total =
                response.data.records_total;
              if (this.terms_data.length === 0) {
                this.setTermsNotFound();
              }

              this.focusStart();
            } else if (response.data.status === -1) {
              this.terms_data = response.data.payload;
              this.filter_current_settings.paging.records_total =
                response.data.records_total;
              if (this.terms_data.length === 0) {
                this.setTermsNotFound(response.data.message);
              }

              this.focusStart();
            } else {
              alert("Došlo k chybě:" + response.data.message);
            }
          } else {
            console.error("Error in connection to server");
            console.error(response.statusText);
          }

          this.unsetLoading();
        })
        .catch(function (error) {
          console.error("Error in fetching data");
          console.error(error);
        });
    },
    setLoading: function () {
      this.is_loading = true;
    },
    unsetLoading: function () {
      this.is_loading = false;
    },
    setTermsNotFound: function (message = false) {
      if (message !== false) {
        this.termsNotFound = message;
      } else {
        this.termsNotFound = true;
      }
    },
    unsetTermsNotFound: function () {
      this.termsNotFound = false;
    },
    focusStart: function () {
      if (this.$refs.hasOwnProperty("filterEl")) {
        this.$scrollTo(this.$refs.filterEl.$el, 500, {
          container: "body",
          duration: 500,
          easing: "ease",
          offset: -200,
          force: true,
          cancelable: true,
          onStart: false,
          onDone: false,
          onCancel: false,
          x: false,
          y: true,
        });
      }
    },
  },
  provide() {
    return {
      language: this.language,
    };
  },
  props: {
    paging_settings_default: {
      type: Object,
      required: false,
      default: function () {
        return {
          page: 1,
          records_total: 120,
          maximum_pages_count: 5,
          records_per_page: 4,
        };
      },
    },
    sort_default_value: {
      type: Number,
      required: false,
      default: 0,
    },
    available_sorts: {
      type: Array,
      required: false,
      default: function () {
        return [
          { legend: "Nejnižší cena", value: 0 },
          { legend: "Nejvyšší cena", value: 1 },
          { legend: "Počet volných pokojů", value: 2 },
        ];
      },
    },
    available_months: {
      required: false,
      type: Array,
      default: function (){
        return ["2021-10-22", "2021-11-22", "2021-12-22"];
      }
    },
    terms: {
      required: false,
      type: Array,
      default: function () {
        return terms_termsoverview;
      },
    },
    currency: {
      required: false,
      default: "Kč",
      type: String,
    },
    api_url: {
      required: false,
      default: "/JSON/term_overview.json",
      type: String,
    },
    api_url_detail: {
      required: false,
      default: "/JSON/term_overview_detail.json",
      type: String,
    },
    api_url_pricing: {
      required: false,
      default: "/JSON/term_overview_pricing.json",
      type: String,
    },
    pricelist_url: {
      type: String | Boolean,
      default: "https://seznam.cz",
      required: false,
    },
    reservation_url: {
      required: false,
      default:
        "https://www.nev-dama.cz/zima/rakousko/stubaital/hotel-alphof/rezervaceNova",
      type: String,
    },
    translations: {
      required: false,
      default: function () {
        return translations_termsoverview;
      },
      type: Object,
    },
    language: {
      type: String,
      default: "cs",
    },
    infant_max_age: {
      type: Number,
      default: 2,
      required: false,
    },
    filter_settings: {
      required: false,
      type: Object,
      default: function () {
        return filter_settings_termsoverview;
      },
    },
    pp: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
};
</script>

<style lang="less">
  @import url("./../../../Content/css/module-term-overview.less");
</style>
